import {
  Alert,
  AlertIcon,
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  VStack,
} from '@elkaso-app/web-design';
import { useDeleteDocumentTypeApi } from 'apis/document-vault/use-delete-document-type-api';
import React, { useCallback } from 'react';

interface DeleteDocumentTypeModalProps {
  isOpen: boolean;
  onClose: () => void;
  documentType: any;
}

export const DeleteDocumentTypeModal: React.FC<DeleteDocumentTypeModalProps> = ({
  isOpen,
  onClose,
  documentType,
}) => {
  const { mutate: deleteDocumentType, isLoading: isDeleting } = useDeleteDocumentTypeApi({
    onSuccess: () => {
      onClose();
    },
  });

  const handleConfirm = useCallback(() => {
    deleteDocumentType(documentType.id);
  }, [deleteDocumentType, documentType.id]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size='md' closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Delete Document Type</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing={4} align='stretch'>
            <Alert status='warning'>
              <AlertIcon />
              This action cannot be undone. Are you sure you want to delete this document type?
            </Alert>
            <VStack spacing={2} align='start'>
              <Text>
                <strong>Name:</strong> {documentType.name}
              </Text>
              <Text>
                <strong>Category:</strong> {documentType.category}
              </Text>
            </VStack>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button variant='outline' mr={3} onClick={onClose} isDisabled={isDeleting}>
            Cancel
          </Button>
          <Button colorScheme='red' onClick={handleConfirm} isLoading={isDeleting} loadingText='Deleting...'>
            Delete
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
